import React from 'react'
import { Row, Col, Form, Input, Typography } from 'antd'
import { handlingFeeMarkup } from '../../../../Utilities/numberValidation'

const { Title } = Typography

const SURCHARGE_FIELDS = [
	{ field: 'freight_direct_surcharge_basic', label: 'Basic' },
	{ field: 'freight_direct_surcharge_basic_appointment', label: 'Basic by Appointment' },
	{ field: 'freight_direct_surcharge_standard', label: 'Standard' },
	{ field: 'freight_direct_surcharge_premium', label: 'Premium' },
]

const FreightDirectSurcharges = ({ quoteSettingsState, handleChange }) => {
	return (
		<Row gutter={30} className={'mb-4'}>
			<Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={6}>
				<Title level={4}>Freight Direct Surcharges</Title>
			</Col>
			<Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={18}>
				{SURCHARGE_FIELDS.map(({ field, label }) => (
					<Row gutter={30} key={field} align='middle' className={'mb-2'}>
						<Col xs={24} sm={12} md={12} lg={12} xl={6}>
							<label className={'text-gray'}>{label}</label>
						</Col>
						<Col xs={24} sm={12} md={12} lg={12} xl={18}>
							<Form.Item className={'mb-0'}>
								<Input
									value={quoteSettingsState[field]}
									onChange={e => handleChange(field, e.target.value)}
									onKeyDown={handlingFeeMarkup}
									maxLength={7}
									type='number'
									min='0'
								/>
							</Form.Item>
						</Col>
					</Row>
				))}
			</Col>
		</Row>
	)
}

export default FreightDirectSurcharges
